import api from '@/api/proxyWeb/settings'

export default {

    get({ commit }) {

        commit('setSettings', null)

        return new Promise(resolve => {

            api.get()
                .then(settings => {
                    commit('setSettings', settings)
                    resolve(settings)
                })
            })      
    },
}